"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.sizes = void 0;
var react_jss_1 = require("react-jss");
var theme_1 = require("../../../../mantine-theme/src");
exports.sizes = {
    xs: 12,
    sm: 16,
    md: 20,
    lg: 26,
    xl: 36,
};
exports.default = react_jss_1.createUseStyles({
    labelDisabled: {},
    wrapper: {
        display: 'flex',
        alignItems: 'center',
        WebkitTapHighlightColor: 'transparent',
    },
    radio: function (_a) {
        var theme = _a.theme, size = _a.size, color = _a.color;
        return (__assign(__assign({}, theme_1.getFocusStyles(theme)), { backgroundColor: theme.colorScheme === 'dark' ? theme.colors.dark[3] : theme.colors.gray[0], border: "1px solid " + (theme.colorScheme === 'dark' ? theme.colors.dark[3] : theme.colors.gray[4]), position: 'relative', appearance: 'none', width: theme_1.getSizeValue({ sizes: exports.sizes, size: size }), height: theme_1.getSizeValue({ sizes: exports.sizes, size: size }), borderRadius: theme_1.getSizeValue({ sizes: exports.sizes, size: size }), margin: 0, marginRight: theme.spacing.sm, background: 'red', display: 'flex', alignItems: 'center', justifyContent: 'center', '&:checked': {
                background: theme_1.getThemeColor({ theme: theme, color: color, shade: theme.colorScheme === 'dark' ? 4 : 6 }),
                borderColor: theme_1.getThemeColor({ theme: theme, color: color, shade: theme.colorScheme === 'dark' ? 4 : 6 }),
                '&::before': {
                    content: '""',
                    display: 'block',
                    backgroundColor: theme.colorScheme === 'dark' ? theme.colors.dark[7] : theme.white,
                    width: theme_1.getSizeValue({ sizes: exports.sizes, size: size }) / 2,
                    height: theme_1.getSizeValue({ sizes: exports.sizes, size: size }) / 2,
                    borderRadius: theme_1.getSizeValue({ sizes: exports.sizes, size: size }) / 2,
                },
            }, '&:disabled': {
                borderColor: theme.colorScheme === 'dark' ? theme.colors.dark[4] : theme.colors.gray[4],
                backgroundColor: theme.colorScheme === 'dark' ? theme.colors.dark[4] : theme.colors.gray[1],
                '&::before': {
                    backgroundColor: theme.colorScheme === 'dark' ? theme.colors.dark[6] : theme.colors.gray[4],
                },
            } }));
    },
    label: function (_a) {
        var theme = _a.theme, size = _a.size;
        return (__assign(__assign({}, theme_1.getFontStyles(theme)), { display: 'flex', alignItems: 'center', fontSize: theme.fontSizes[size] || theme.fontSizes.md, lineHeight: theme_1.getSizeValue({ sizes: exports.sizes, size: size }) + "px", color: theme.colorScheme === 'dark' ? theme.colors.dark[0] : theme.black, '&$labelDisabled': {
                color: theme.colorScheme === 'dark' ? theme.colors.dark[3] : theme.colors.gray[5],
            } }));
    },
}, { link: true });
